/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import TakePhotos from '../TakePhotos/TakePhotos';

class FnolStep6Sub1 extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.state = {}
    }
    public render() {
        return (<TakePhotos/>)
        }
    }


const mapStateToProps = (state: any) => {
    return {
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FnolStep6Sub1)